import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-simulador',
  templateUrl: './simulador.component.html',
  styleUrls: ['./simulador.component.scss']
})
export class SimuladorComponent   {

  Label_Simulador=environment.LABEL_SIMULADOR;
  constructor(private loginService:LoginService) { }

  

  
  clickGuard(){
    this.loginService.clickGuard = true;
 }

}
